import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";
import { OLTheme } from "contexts/Theme/ThemeProvider";

export const useStyles = makeStyles((theme: OLTheme) =>
  createStyles({
    link: {
      color: theme.primary500,
      display: "flex",
      textDecoration: "none",
      fontSize: 16,

      "& svg": {
        margin: theme.spacing(0, 4),
        fill: theme.primary500,
      },
    },
    linkWrapper: {
      padding: theme.spacing(4),
      marginBottom: theme.spacing(4),
    },
    storeNameButton: {
      backgroundColor: "rgba(255, 255, 255, 0.09)",
      borderRadius: theme.spacing(2),
      color: theme.white50,
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
      margin: theme.spacing(0, 6),
      padding: theme.spacing(6, 8, 6, 0),
      textTransform: "none",
      width: "100%",
      "& div:focus": {
        background: theme.primary500,
      },

      "&:hover": {
        backgroundColor: "#F2F2F2",
      },
    },
    storeCode: {
      color: theme.black,
      marginBottom: theme.spacing(1),
      overflow: "hidden",
      whiteSpace: "nowrap",
      textOverflow: "ellipsis",
    },
    dropdownIconWrapper: {
      marginLeft: theme.spacing(4),
      marginTop: theme.spacing(3),

      "& svg": {
        color: theme.black,
      },
    },
    currency: {
      color: "#6D6D6D",
      marginLeft: theme.spacing(1),
      wordBreak: "keep-all",
    },
    search: {
      padding: theme.spacing(6, 4),
      "& input": {
        color: theme.gray500,
        fontWeight: 400,

        "&::placeholder": {
          color: theme.gray500,
          opacity: 1,
        },
      },
    },
    searchIcon: {
      marginRight: theme.spacing(6),
      color: theme.gray500,
    },
    additionalMenu: {
      backgroundColor: theme.primary700,
      boxShadow:
        "0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12)",
      marginLeft: theme.spacing(5),
      marginTop: theme.spacing(-10),
    },
    additionalMenuListItem: {
      color: theme.gray800,
      fontSize: 16,
      fontWeight: 400,
      padding: theme.spacing(4),
      textDecoration: "none",
      whiteSpace: "normal",
      cursor: "pointer",
      borderRadius: "8px",
      wordBreak: "break-word",

      "&:hover": {
        background: theme.gray50,
      },
    },
    listWrapper: {
      padding: theme.spacing(4),
    },
    divider: {
      "&.MuiDivider-root": {
        borderColor: theme.gray100,
      },
    },
    storeNameButtonSmallContainer: {
      padding: theme.spacing(0, 8),
    },
    storeNameButtonSmall: {
      backgroundColor: "#F2F2F2",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      height: "48px",
      width: "48px",
      border: `1px solid ${theme.gray100}`,
      borderRadius: "4px",
      color: theme.black,
      fontSize: "16px",
      fontWeight: 500,
      cursor: "pointer",
      padding: theme.spacing(7),
    },
    buttonPosition: {
      display: "flex",
      maxWidth: "100%",
    },

    storeWrapper: {
      display: "flex",
      flexDirection: ({ isDrawerOpen }: { isDrawerOpen?: boolean }) =>
        isDrawerOpen ? "row" : "column",
      alignItems: "center",
      padding: theme.spacing(1, 8),
      gap: ({ isDrawerOpen }) => (isDrawerOpen ? 0 : theme.spacing(5)),
      margin: ({ isDrawerOpen }) => (isDrawerOpen ? 0 : theme.spacing(6, 0, 0)),

      "&:hover": {
        backgroundColor: ({ isDrawerOpen }) =>
          isDrawerOpen ? "#F2F2F2" : "none",
      },
    },
    loading: {
      color: theme.gray800,
      fontSize: 16,
      fontWeight: 400,
      padding: theme.spacing(4),
      display: "flex",
      justifyContent: "space-between",
    },
    globalAdmin: {
      fontSize: 14,
      fontWeight: 500,
    },
    globalManagementWrapper: {
      padding: theme.spacing(7, 8),
    },
  }),
);
